import Body, { BodyProps } from '../Body/Body';

interface PageIngressProps {
  text: Required<BodyProps>['richText'];
  rightContent?: React.ReactNode;
}

const PageIngress: React.FC<PageIngressProps> = ({
  text,
  rightContent = <></>,
}) => {
  return (
    <div className="flex w-full flex-col tablet:flex-row gap-64 tablet:gap-24 laptop:px-128">
      <Body className="text-lg tablet:text-xl w-full" richText={text} />

      <div className="w-full">{rightContent}</div>
    </div>
  );
};

export default PageIngress;
